import { Routes } from '@angular/router';
import { authGuard } from '@auth/guards/auth.guard';
import { loginGuard } from '@auth/guards/login.guard';
import { requireAllRoles, requireAnyRole } from '@auth/guards/role.guard';
import { ROLES } from '@auth/models/roles.model';

export const routes: Routes = [
  // {
  //   path: 'home',
  //   loadComponent: () =>
  //     import('@core/pages/home/home.page').then(m => m.HomePage),
  //   // Home is always accessible
  // },
  {
    path: 'home',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'login',
    canActivate: [loginGuard], // Prevent access when already logged in
    loadComponent: () =>
      import('@auth/pages/login/login.page').then(m => m.LoginPage),
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('@auth/pages/unauthorized/unauthorized.page').then(
        m => m.UnauthorizedPage
      ),
    // Unauthorized page is always accessible
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () =>
      import('@core/pages/dashboard/dashboard.page').then(m => m.DashboardPage),
  },
  {
    path: 'save-as-you-pay',
    canActivate: [authGuard],
    children: [
      {
        path: 'landing',
        canActivate: [requireAllRoles(ROLES.SAYP_VIEW)],
        loadComponent: () =>
          import('@save-as-you-pay/pages/landing/landing.page').then(
            m => m.SaypLandingPage
          ),
      },
      {
        path: 'account-details/:id',
        canActivate: [requireAllRoles(ROLES.SAYP_VIEW)],
        loadComponent: () =>
          import('@save-as-you-pay/pages/account-details/account-details.page').then(
            m => m.AccountDetailsPage
          ),
      },
      {
        path: 'enroll-customer',
        canActivate: [requireAllRoles(ROLES.SAYP_ENROLL)],
        loadComponent: () =>
          import('@save-as-you-pay/pages/enroll-customer/enroll-customer.page').then(
            m => m.EnrollCustomerPage
          ),
      },
      {
        path: 'program-settings',
        canActivate: [requireAllRoles(ROLES.SAYP_CONFIGURE)],
        loadComponent: () =>
          import('@save-as-you-pay/pages/program-settings/program-settings.page').then(
            m => m.ProgramSettingsPage
          ),
      },
      {
        path: 'transactions/:accountId',
        canActivate: [requireAllRoles(ROLES.SAYP_VIEW)],
        loadComponent: () =>
          import('@save-as-you-pay/pages/transactions/transactions.page').then(
            m => m.TransactionsPage
          ),
      },
      {
        path: 'transaction-requests/:accountId',
        canActivate: [
          requireAnyRole(ROLES.SAYP_REQUESTER, ROLES.SAYP_AUTHORIZER),
        ],
        loadComponent: () =>
          import('@save-as-you-pay/pages/transaction-requests/transaction-requests.page').then(
            m => m.TransactionRequestsPage
          ),
      },
      {
        path: 'statement-manager',
        canActivate: [requireAllRoles(ROLES.SAYP_STATEMENTS)],
        loadComponent: () =>
          import('@save-as-you-pay/pages/statement-manager/statement-manager.page').then(
            m => m.StatementManagerPage
          ),
      },
      {
        path: 'reports',
        canActivate: [requireAllRoles(ROLES.SAYP_REPORTS)],
        loadComponent: () =>
          import('@app/save-as-you-pay/pages/reports/reports-shell/reports-shell.page').then(
            m => m.ReportsShellPage
          ),
        children: [
          {
            path: '',
            loadComponent: () =>
              import('@save-as-you-pay/pages/reports/reports.page').then(
                m => m.ReportsPage
              ),
          },
          {
            path: 'operational',
            loadComponent: () =>
              import('@save-as-you-pay/pages/reports/operational/operational-reports.page').then(
                m => m.OperationalReportsPage
              ),
          },
          {
            path: 'financial',
            loadComponent: () =>
              import('@save-as-you-pay/pages/reports/financial/financial-reports.page').then(
                m => m.FinancialReportsPage
              ),
          },
          {
            path: 'customer',
            loadComponent: () =>
              import('@save-as-you-pay/pages/reports/customer/customer-reports.page').then(
                m => m.CustomerReportsPage
              ),
          },
          {
            path: 'reconciliation',
            loadComponent: () =>
              import('@save-as-you-pay/pages/reports/reconciliation/reconciliation-reports.page').then(
                m => m.ReconciliationReportsPage
              ),
          },
        ],
      },
      {
        path: 'flagged-transactions',
        canActivate: [requireAllRoles(ROLES.SAYP_FLAGGED_MATCH)],
        loadComponent: () =>
          import('@save-as-you-pay/pages/flagged-transactions/flagged-transactions.page').then(
            m => m.FlaggedTransactionsPage
          ),
      },
      {
        path: 'flagged-transactions/:id/match',
        canActivate: [requireAllRoles(ROLES.SAYP_FLAGGED_MATCH)],
        loadComponent: () =>
          import('@save-as-you-pay/pages/match-flagged-transaction/match-flagged-transaction.page').then(
            m => m.MatchFlaggedTransactionPage
          ),
      },
      {
        path: '**',
        redirectTo: 'landing',
      },
    ],
  },
  {
    path: 'customer',
    canActivate: [authGuard, requireAllRoles(ROLES.PDI_ACCOUNT_VIEW)],
    children: [
      {
        path: 'landing',
        loadComponent: () =>
          import('@customer/pages/landing/landing.page').then(
            m => m.CustomerLandingPage
          ),
      },
      {
        path: 'details',
        loadComponent: () =>
          import('@customer/pages/customer-details/customer-details.page').then(
            m => m.CustomerDetailsPage
          ),
      },
      {
        path: '**',
        redirectTo: 'landing',
      },
    ],
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];
